module.exports = __webpack_public_path__ + "static/media/available_real_estate_sold.f9337953.jpg";